import * as TYPES from '../types';
import { SUBSCRIBER, REDUX_CONSTANT } from '../../constants';

const initialState = {
    subscriptionTypeList: [
        { name: 'All', type: 'item' },
        { name: 'Prep', type: 'item' },
        { name: 'LawHub Advantage', type: 'item' }
    ],
    linkStatusList: [
        { name: 'All', type: 'item' },
        { name: 'Linked', type: 'item' },
        { name: 'Not Linked', type: 'item' }
    ],
    reportsList: [{ name: 'Vendor Site Login History', type: 'item' }],
    isLoading: false
};

export default function getStudentLogHistoryInformation(
    state = initialState,
    action
) {
    switch (action.type) {
        case REDUX_CONSTANT.GET_REPORT_STUDENT_LOG_HISTORY:
            return {
                ...state,
                isLoading: false,
                logHistoryData:
                    action.payload &&
                    action.payload.items &&
                    action.payload.items.length > 0
                        ? action.payload.items
                        : [],
                recordCount: action.payload.recordCount,
                sortOrder: action.payload.sortOrder,
                pageSize: action.payload.pageSize,
                pageNumber: action.payload.pageNumber,
                sortField: action.payload.sortField,
                fromDate: action.payload.fromDate,
                toDate: action.payload.toDate,
                searchText: action.payload.searchText,
                subscriptionType: action.payload.subscriptionType,
                linkedStatus: action.payload.linked,
                vendorId: action.payload.vendorId
            };
        case REDUX_CONSTANT.LOGOUT_RESET:
            state = initialState;
            return {
                ...state
            };
        case TYPES.ON_LOAD:
            return {
                ...state,
                isLoading: true
            };
        case TYPES.ERROR:
            return {
                ...state,
                isLoading: false,
                logHistoryData:
                    action.payload.title ==
                    REDUX_CONSTANT.GET_REPORT_STUDENT_LOG_HISTORY
                        ? []
                        : state.logHistoryData
            };
        default:
            return state;
    }
}
